import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setAccountPreferences } from 'features/auth/authSlice'
import { updateLanguagePreference } from 'features/settings/settingSlice'
import { changeAppLanguage } from './appLanguage'
import { getLanguageConfig, SUPPORTED_LANGUAGES } from './config'

export const useAppLanguage = () => {
  const dispatch = useDispatch()
  const account = useSelector((state) => state.auth.user)
  const isChangingLanguage = useSelector(
    (state) => state.settings.languageChangeLoading
  )
  const languageChangeError = useSelector(
    (state) => state.settings.languageChangeError
  )
  const { i18n } = useTranslation()

  const changeLanguage = useCallback(
    (language) =>
      changeAppLanguage({
        language,
        isAuthenticated: Boolean(account?.token),
        updateRemote: (nextLanguage) =>
          dispatch(updateLanguagePreference(nextLanguage)).unwrap(),
        updateAccount: (preferences) =>
          dispatch(setAccountPreferences(preferences)),
        i18nInstance: i18n,
      }),
    [account?.token, dispatch, i18n]
  )

  return {
    currentLanguage: i18n.resolvedLanguage || i18n.language,
    currentLocale: getLanguageConfig(i18n.resolvedLanguage || i18n.language).locale,
    supportedLanguages: SUPPORTED_LANGUAGES,
    changeLanguage,
    isChangingLanguage,
    languageChangeError,
  }
}
